<template>
  <div>
    <!-------------Start toast / snackbar --------------------------->
    <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />
    <!-------------end toast / snackbar --------------------------->
    <!--------- heading ------------------->
    <v-row flat>
      <v-col cols="12" md="4">
        <h1 class="heading-1 mobile_size_h1">Seminars</h1>
      </v-col>
      <v-col cols="12" md="8">
        <v-card flat class="d-flex justify-end mt-2">
          <v-btn
            color="primary"
            dark
            class="text_style px-7"
            depressed
            @click="addDialog = true"
          >
            Add new
          </v-btn>

          <v-dialog v-model="addDialog" max-width="600" persistent>
            <v-card class="" v-if="addDialog">
              <addnewseminar
                :addDialog="addDialog"
                :InstructorsArray="GetAllInstructorsIDsAndNames"
                @close="close"
              ></addnewseminar>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>
    <!--------- search , filter and buttons ------------------->
    <v-row class="mt-6" justify="center" align-content="center">
      <v-col cols="12" md="4" sm="6">
        <v-card flat>
          <v-text-field
            dense
            outlined
            prepend-inner-icon="mdi-magnify"
            label="Search"
            single-line
            v-model="search"
            @input="searchData()"
          >
          </v-text-field>
        </v-card>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <v-card
          height="45"
          outlined
          class="px-2 mt-n1 d-flex justify-start align-center"
          style="cursor: pointer"
          @click="filterDialog = true"
        >
          <div
            class="d-flex justify-space-between align-center"
            style="width: 100%"
          >
            <div>
              <v-icon>mdi-tune</v-icon>
              <span class="text_style mx-1" style="letter-spacing: 1px"
                >Filters</span
              >
            </div>

            <div>
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
        </v-card>
        <!-- <v-card flat>
          <v-select
          :items="filterItem"
            dense
            outlined
            prepend-inner-icon="mdi-tune"
            label="Filters"
            single-line
          >
          </v-select>
        </v-card> -->
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-card flat>
          <v-dialog v-model="createnewgroupdialog" persistent max-width="600">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                block
                class="text_style mt-n1"
                height="42.5px"
                color="primary"
                outlined
                v-if="Permission.Add"
                >Create New Group</v-btn
              >
            </template>
            <v-card>
              <div class="mx-8 py-5 d-flex justify-space-between">
                <span class="heading-2"> <b> Create New Group</b></span>
                <v-icon @click="createnewgroupdialog = false">mdi-close</v-icon>
              </div>
              <div>
                <createnewgroup-component />
              </div>
              <div class="d-flex justify-end mx-5 py-5">
                <v-btn
                  color="#A1A3A8"
                  class="px-14 py-6 text_style"
                  text
                  @click="createnewgroupdialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  class="px-14 py-6 text_style"
                  @click="send()"
                >
                  <span class="pa-4 text_style" v-if="btnloader != true">
                    Save
                  </span>
                  <v-progress-circular
                    indeterminate
                    v-else
                    size="20"
                    class="px-5"
                    color="white"
                    v-show="btnloader"
                  ></v-progress-circular>
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-card flat>
          <v-dialog v-model="uploadfiledialog" persistent max-width="600">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                block
                class="text_style mt-n1"
                height="42.5px"
                depressed
                v-if="Permission.Add"
                color="primary"
                >Upload new file</v-btn
              >
            </template>
            <v-card>
              <div class="mx-8 py-5 d-flex justify-space-between">
                <span class="heading-2"> <b> Upload new file</b></span>
                <v-icon @click="uploadfiledialog = false">mdi-close</v-icon>
              </div>
              <div>
                <UploadfileComponent />
              </div>
              <div class="d-flex justify-end mx-5 py-5">
                <v-btn
                  class="px-14 py-6 text_style"
                  color="#A1A3A8"
                  text
                  @click="uploadfiledialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  class="px-14 py-6 text_style"
                  @click="send()"
                >
                  <span class="pa-4 text_style" v-if="btnloader != true">
                    Save
                  </span>
                  <v-progress-circular
                    indeterminate
                    size="20"
                    v-else
                    class="px-5"
                    color="white"
                    v-show="btnloader"
                  ></v-progress-circular>
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="filterDialog" max-width="430" persistent>
      <v-card class="py-5" v-if="filterDialog">
        <v-card-title class="mb-5 d-flex justify-space-between align-center">
          <div class="text-h5"><b> Filters</b></div>
          <div>
            <v-btn text depressed class="pa-0" @click="cleanFilter()">
              <span class="text_style primary--text" style="letter-spacing: 0px"
                >Clean filters</span
              >
            </v-btn>
            <v-icon class="ml-3" @click="filterDialog = false"
              >mdi-close</v-icon
            >
          </div>
        </v-card-title>

        <v-card-text>
          <v-select
            outlined
            v-model="filterCourse"
            :items="GetSeminarCoursesAndInstructors.CoursesList"
            item-text="Title"
            dense
            hide-details
            label="Course"
            multiple
            persistent-hint
            :menu-props="{ maxHeight: '400' }"
          ></v-select>
          <!-- <v-select
            outlined
            class="my-5"
            v-model="filtercity"
            :items="GetFilterOptionsData.Cities"
            dense
            :menu-props="{ maxHeight: '400' }"
            hide-details
            label="City"
            multiple
            persistent-hint
          ></v-select>
          <v-select
            outlined
            v-model="filtercountry"
            :items="GetFilterOptionsData.Countries"
            dense
            :menu-props="{ maxHeight: '400' }"
            hide-details
            label="Country"
            multiple
            persistent-hint
          ></v-select> -->
          <!-- <v-select
            outlined
            class="my-5"
            v-model="filterseminar"
            :items="filterseminarArray"
            :menu-props="{ maxHeight: '400' }"
            dense
            hide-details
            label="IBA Seminar"
            persistent-hint
          ></v-select> -->
          <v-select
            outlined
            class="my-5"
            v-model="filterInstructor"
            :items="instructorList"
            item-text="Name"
            :menu-props="{ maxHeight: '400' }"
            dense
            hide-details
            label="Instructor"
            multiple
            persistent-hint
          ></v-select>
          <!-- <v-select
            outlined
            class="my-5"
            v-model="filtermonth"
            :items="filtermonthArray"
            :menu-props="{ maxHeight: '400' }"
            dense
            hide-details
            label="Month"
            multiple
            persistent-hint
          ></v-select> -->
          <v-menu
            ref="datarangemenu"
            v-model="datarangemenu"
            :close-on-content-click="false"
            :return-value.sync="Renewaldates"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="Renewaldates"
                append-icon="mdi-calendar"
                readonly
                label="Date"
                class="my-5"
                dense
                hide-details
                outlined
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dates" no-title scrollable range>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="datarangemenu = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.datarangemenu.save(Renewaldates)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-select
            outlined
            class="my-5"
            v-model="filterStatus"
            :items="filterStatusArray"
            :menu-props="{ maxHeight: '400' }"
            dense
            hide-details
            label="Status"
            persistent-hint
          ></v-select>
          <!---------------------Type-modalitiy model filter-------------------------------->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#646464"
            outlined
            depressed
            class="px-5"
            text
            @click="filterDialog = false"
          >
            <span class="text_style"> Cancel </span>
          </v-btn>
          <v-btn
            color="primary"
            class="px-8 ml-2"
            @click="handleSaveFilter()"
            depressed
          >
            <span class="text_style">
              Save Filters
            </span>
            
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------- data table ------------------->
    <v-card class="mt-6" outlined>
      <v-data-table
        :headers="headers"
        :loading="tableLoader"
        loading-text="Loading... Please wait"
        :items="GetSeminars"
        :page.sync="page"
        :items-per-page="displayedItemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:[`item.index`]="{ index }">
          <!-- + displayedItemsPerPage * (page - 1) + -->
          <b> {{ index + displayedItemsPerPage * (page - 1) + 1 }} </b>
        </template>
        <!-- <template v-slot:[`item.Course.Title`]="{ item }">
          <span class="table_style_one"> {{ item.Course.Title }} </span>
        </template> -->
        <template v-slot:[`item.Instructor`]="{ item }">
          <span class="table_style_two"> {{ item.Instructor.FirstName }} {{ item.Instructor.LastName }} </span>
        </template>
        <template v-slot:[`item.SeminarDate`]="{ item }">
          <span class="table_style_two"> {{ extractMonthAndDate(item, 0)}} </span>
        </template>
        <template v-slot:[`item.Location`]="{ item }">
          <span class="table_style_two" v-if="item.Type == 1">
            {{ item.Location.LocationName }},{{ item.Location.City }},
            {{ item.Location.Country }}
            <span v-if="item.AvailableOnline" class=""
                >and <v-icon>mdi-youtube-tv</v-icon> Online</span
              >
          </span>
          <span class="table_style_two" v-else>
            Online
          </span>
        </template>

        <!-- <div>
            <span class="table_style_two">
              {{ checkDate(item.ModifiedDate) }}
            </span>
          </div> -->

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="toggleIsPlaying(item.Id)">
            <v-icon v-if="item.Visibility" color="primary">mdi-eye</v-icon>
            <v-icon v-else>mdi-eye-off</v-icon>
          </v-btn>
          <v-menu transition="scroll-y-transition" offset-y color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <v-card flat>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="seminarDialogOpen(item.Id)"
                >
                  <v-icon color="#646464">mdi-open-in-new</v-icon>
                  <span class="ml-4 text_style">See Seminar</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="seeStudents(item)"
                >
                  <v-icon color="#646464">mdi-account</v-icon>
                  <span class="ml-4 text_style">See Students</span>
                </v-btn>
              </v-list>

              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="editDialogSeminar(item)"
                >
                  <v-icon color="#646464">mdi-pencil</v-icon>
                  <span class="ml-4 text_style">Edit</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="deleteDialogSeminar(item.Id)"
                >
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_style">Delete</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select
          :items="ItemsPerPageItems"
          label="Items per page"
          v-model="itemsPerPage"
          @change="handleItemPerPage()"
        ></v-select>
      </v-card>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
        @input="fetchData"
      ></v-pagination
    ></v-card>
    <v-dialog v-model="seminardialog" max-width="700" persistent>
      <v-card class="pa-3" v-if="seminardialog">
        <div class="d-flex justify-end">
          <v-icon @click="seminardialog = false">mdi-close</v-icon>
        </div>
        <div>
          <seeseminar :Id="setId" />
        </div>
        <!-- <v-card-actions class="px-11">
          <v-btn color="primary" class="my-6 py-6" depressed to="/" block :disabled="btn-loader">
          <span v-if="btnloader != true">ADD TO CART</span>
          <v-progress-circular
            v-else
            indeterminate
            size="20"
            class="px-5"
            color="white"
            v-show="btnloader"
          ></v-progress-circular
        >   -->
        <!-- <v-card-actions class="px-11">
          <v-btn color="primary" class="my-6 py-6" depressed to="/" block>
            ADD TO CART
          </v-btn>
        </v-card-actions> -->
        <div
          class="px-11 lightgrey d-flex justify-center pb-9"
          style="font-size: 12px; text-align: center"
        >
          By clicking this button, you submit your information to the webinar
          organizer, who will use it to communicate with you regarding this
          event and their other services.
        </div>
      </v-card>
    </v-dialog>
    <!----------Edit dialog------------------>
    <v-dialog v-model="editdialog" persistent max-width="600">
      <v-card v-if="editdialog">
        <div>
          <editseminar
            :setDataEditSeminar="setDataEditSeminar"
            :EditSeminar="editdialog"
            @close="close"
            :InstructorsArray="GetAllInstructorsIDsAndNames"
          />
        </div>
      </v-card>
    </v-dialog>
    <!----------Delete dialog------------------>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            depressed
            :disabled="btnloader"
            @click="DdialogClose()"
          >
            <span v-if="btnloader != true"> confirm </span>
            <v-progress-circular
              v-else
              indeterminate
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import createnewgroupComponent from "../../components/download/createnewgroup.component.vue";
import UploadfileComponent from "../../components/download/uploadfile.component.vue";
import Addnewseminar from "../../components/Seminar/addnewseminar.vue";
import editseminar from "../../components/Seminar/editseminar.vue";
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import Seeseminar from "../../components/Seminar/seeseminar.vue";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    createnewgroupComponent,
    UploadfileComponent,
    SuccessToastComponent,
    ErrorToastComponent,
    Addnewseminar,
    editseminar,
    Seeseminar,
  },
  data() {
    return {
      datarangemenu: false,
      dates: [],
      setId: null,
      setDataEditSeminar: null,
      filtersArray: [],
      seminardialog: false,
      isPlaying: false,
      addDialog: false,
      search: "",
      filterCourse: [],
      filterCourseArray: ["[course_names]"],
      filtercity: [],
      filtercityArray: ["[city_names]"],
      filtercountry: [],
      filtercountryArray: ["[Country_name]"],
      filterseminar: [],
      filterseminarArray: ["YES", "NO"],
      filtermonth: [],
      filtermonthArray: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      filterStatus: [],
      filterStatusArray: ["Active", "Inactive"],
      filterInstructor: [],
      filterInstructorArray: ["Instructor"],
      filterDialog: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      SuccessToast: false,
      ErrorToast: false,
      uploadfiledialog: false,
      createnewgroupdialog: false,
      editdialog: false,
      btnloader: false,
      tableLoader: false, // data-table true or false
      dialog: false,
      seachTimer: 0,
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "Course", value: "Course.Title" },
        { text: "Instructor", value: "Instructor", sortable: false },
        { text: "Location", value: `Location`, sortable: false },
        { text: "Start Date", value: `SeminarDate` },
        // { text: "New Students", value: "NewStudents" },
        { text: "Total Students", value: "TotalStudents", sortable: false },
        { text: "Status", value: "Status", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },

  mounted() {
    
    const savedFilters = JSON.parse(localStorage.getItem("seminarFilters"));
    if (savedFilters) {
      this.filterCourse = savedFilters.filterCourse || [];
      this.filterStatus = savedFilters.filterStatus || [];
      this.filtercity = savedFilters.filtercity || [];
      this.filtercountry = savedFilters.filtercountry || [];
      this.filterInstructor = savedFilters.filterInstructor || [];
      this.dates = savedFilters.dates || [];
      this.search = savedFilters.search || "";
      this.itemsPerPage = savedFilters.itemsPerPage || 10;
      this.page = savedFilters.page || 1;
      this.handleSaveFilter();
    }
    this.getSeminarsList()
    if (this.$route.query.courseId !== undefined) {
      if (!localStorage.getItem("dialogShown")) {
        this.addDialog = true;
        localStorage.setItem("dialogShown", "true");
      }
    }
  },
  beforeDestroy() {
    localStorage.setItem("dialogShown", "");
  },
  computed: {
    ...mapGetters([
      "GetSeminars",
      "GetAllInstructorsIDsAndNames",
      "GetCoursesIDsAndTitle",
      "GetLoggedInUser",
      "GetFilterOptionsData",
      "GetSeminarCoursesAndInstructors"
    ]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetSeminars.length
        : this.itemsPerPage;
    },
    Renewaldates() {
      return this.dates.join(" to ");
    },
    instructorList() {
      return this.GetSeminarCoursesAndInstructors?.InstructorList?.map(item => item.FirstName + " " + item.LastName)
    }
  },
  beforeRouteLeave(to, from, next) {
    // Check if the next route does not start with '/seminarstudent'
    if (!to.path.startsWith('/seminarstudent')) {
      localStorage.removeItem('seminarFilters');
    }
    next();
  },
  methods: {
    async getSeminarsList(){
      await this.fetchData();
      await this.$store.dispatch("GetSeminarCoursesAndInstructors");
      await this.$store.dispatch("GetCoursesIDsAndTitle");
      this.$store.dispatch("GetAllInstructorsIDsAndNames")
    },
    seeStudents(item) {
      const filters = {
        filterCourse: this.filterCourse,
        filterStatus: this.filterStatus,
        filtercity: this.filtercity,
        filtercountry: this.filtercountry,
        filterInstructor: this.filterInstructor,
        dates: this.dates,
        search: this.search,
        itemsPerPage: this.itemsPerPage,
        page: this.page,
      };
      localStorage.setItem("seminarFilters", JSON.stringify(filters));
      this.$store.state.seminarId = item.Id;
      this.$store.state.courseName = item.Course.Title;
      this.$router.push(`/seminarstudent/${item.Id}`);
    },
    handleItemPerPage() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.fetchData();
    },
    seminarDialogOpen(userInfoId) {
      this.seminardialog = true;
      this.setId = userInfoId;
    },
    async handleSaveFilter() {
      this.btnloader=true;
      setTimeout(() => {
        this.filterDialog = false;
        this.btnloader = false;
      }, 500);
      this.filtersArray = [];
      if (this.filterCourse.length > 0) {
        this.filtersArray.push({
          Key: "Course",
          Value: this.filterCourse.join(","),
        });
      }
      if (this.filtercity.length > 0) {
        this.filtersArray.push({
          Key: "city",
          Value: this.filtercity.join(","),
        });
      }
      if (this.filtercountry.length > 0) {
        this.filtersArray.push({
          Key: "country",
          Value: this.filtercountry.join(","),
        });
      }
      if (this.filterStatus.length > 0) {
        this.filtersArray.push({
          Key: "status",
          Value: this.filterStatus,
        });
      }
      if (this.dates.length > 0) {
        this.filtersArray.push({
          Key: "date",
          Value: this.dates.join(","),
        });
      }
      if (this.filterInstructor.length > 0) {
        this.filtersArray.push({
          Key: "instructorfirstname",
          Value: this.filterInstructor.join(","),
        });
      }
      // if (this.filterseminar.length > 0) {
      //   this.filtersArray.push({
      //     Key: "Seminar",
      //     Value: this.filterseminar,
      //   });
      // }
      // try {
      this.page = 1;
      this.filtersArray = JSON.stringify(this.filtersArray);
      await this.fetchData();
      // } catch (e) {
      //   console.error(e);
      // }
    },
    editDialogSeminar(data) {
      this.setDataEditSeminar = data;
      this.editdialog = true;
    },
    deleteDialogSeminar(id) {
      this.dialog = true;
      this.setId = id;
    },
    searchData(){
      clearTimeout(this.seachTimer);
      this.seachTimer = setTimeout(() => {
        this.page = 1;
      this.fetchData()
      }, 700);
    },
    async fetchData() {
      const obj = {
        // page: this.search ? 1 : this.page,
        page: this.page,
        pageSize: this.itemsPerPage,
        search: this.search,
        filters: this.filtersArray,
      };
      this.tableLoader = true;
      await this.$store
        .dispatch("GetAllSeminar", obj)
        .then((res) => {
          this.tableLoader = false;
          // this.pageCount = Math.ceil(res.totalRecords / this.itemsPerPage);
          if (this.itemsPerPage !== "All") {
            this.pageCount = Math.ceil(res.totalRecords / this.itemsPerPage);
          } else {
            this.pageCount = 1;
          }
        })
        .catch(() => {
          this.tableLoader = false;
        });
    },
    extractMonthAndDate(item, index) {
      if (!item.SeminarDateAndTimes?.length) return "";

      const utcDate = item.SeminarDateAndTimes[index].StartTime;
      if (!utcDate) return "";

      let sourceTimezone;

      if (item.Type === 1 && item.Location?.TimeZone) {
        sourceTimezone = item.Location.TimeZone;
      } else if (item.Type === 2 && item.Timezone) {
        sourceTimezone = item.Timezone;
      } else {
        sourceTimezone = moment.tz.guess();
      }

      const utcMoment = moment.utc(utcDate);

      // online → show in viewer's local time (for their own convenience)
      if (item.Type === 2) {
        return utcMoment.local().format("YYYY-MM-DD");
      }

      // in-person → show in the seminar's own location timezone, so the
      // displayed date never shifts depending on who is viewing it
      return utcMoment.tz(sourceTimezone).format("YYYY-MM-DD");
    },
    toggleIsPlaying(id) {
      this.$store.dispatch("ToggleSeminarVisibility", id).then(() => {
        this.fetchData();
      });
    },
    DdialogClose() {
      const obj = {
        Id: this.setId,
      };
      this.btnloader = true;
      this.$store.dispatch("DeleteSeminar", obj).then(() => {
        this.dialog = false;
        this.btnloader = false;
        this.fetchData();
        // this.SuccessToast = true;
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Deleted Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      });
    },
    goBack() {
      this.isHidden = false;
    },
    send() {
      // setTimeout(() => {
      //   this.btnloader = true;
      // }, 100);
      setTimeout(() => {
        this.editdialog = false;
        // this.btnloader = false;
        this.uploadfiledialog = false;
        this.createnewgroupdialog = false;
        this.SuccessToast = true;
      }, 2000);
      setTimeout(() => {
        this.SuccessToast = false;
      }, 3000);
    },
    close() {
      this.addDialog = false;
      this.editdialog = false;
      this.SuccessToast = false;
      this.ErrorToast = false;
      this.fetchData();
    },
    cleanFilter() {
      this.filterCourse = [];
      this.filterStatus = [];
      this.filtercity = [];
      this.filtercountry = [];
      this.filterseminar = [];
      this.filtermonth = [];
      this.filterInstructor = [];
      this.dates = [];
      localStorage.removeItem("seminarFilters");
    },
    checkDate(x) {
      return moment(x).format("MM/DD/YY");
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: "Noto Serif";
  font-size: 40px;
  font-weight: 700;
  line-height: 54px;
  color: rgba(34, 34, 34, 1);
}
@media screen and (max-width: 430px) {
  .mobile_size_h1 {
    font-size: 6vw;
  }
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
.heading {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 31px;

  /* Color/General/Black High Emphasis */

  color: #222222;
}
</style>
